import { AuthProvider } from "@/context";
import ScrollToTop from "@/lib/ScrollToTop";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { BrowserRouter, Navigate, Route, Routes } from "react-router";
import { ToastContainer } from "react-toastify";
import Auth from "./Auth";
import Dashboard from "./Dashboard";
import JoinTeam from "./JoinTeam";
import { RequireAuth } from "./privateRoute";
import Accept from "@/pages/dashboard/settings/Accept";
function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: { refetchOnWindowFocus: false, refetchOnMount: true },
    },
  });
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop>
            <Routes>
              {/* <Route path={"/auth/*"} element={<Auth />} /> */}
              <Route path={"/*"} element={<Auth />} />
              <Route path="/teams/invite/accept/:token" element={
                <RequireAuth>
                  <Accept />
                </RequireAuth>
              } />
              <Route path={"/teams/*"} element={<JoinTeam />} />
              <Route
                path={"/dashboard/*"}
                element={
                  <RequireAuth>
                    <Dashboard />
                  </RequireAuth>
                }
              />
              {/* <Route
                path="/"
                element={<Navigate replace to="/" />}
              /> */}
            </Routes>
          </ScrollToTop>
        </BrowserRouter>
        <ToastContainer />
      </AuthProvider>
      <ReactQueryDevtools />
    </QueryClientProvider>
  );
}

export default App;
